module.exports = __webpack_public_path__ + "static/img/bear.166e19e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bday/bear.svg
// module id = L1mg
// module chunks = 1